import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {GlossaryInfoModal} from 'shells/glossary-info-modal/glossary-info-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

export function DripSequenceInfoModal() {
    const {onClose} = useOpenableModal(OpenableModals.DRIP_SEQUENCE_INFO_MODAL);

    return (
        <GlossaryInfoModal
            onClose={onClose}
            artImage={
                <img
                    src='/include/images/onboarding/drip-sequence-doodle.svg'
                    alt='Drip sequence doodle'
                />
            }
            title='What is a drip sequence?'
            body={
                <div>
                    <p>
                        A drip sequence is a series of messages that all relate to the same topic.
                        Configure your sequence to send on a cadence by setting delays between each
                        message.
                        <br />
                    </p>
                    <p>
                        Drip sequences are automated by three key components:
                        <br />
                    </p>
                    <BulletedList
                        bullets={[
                            <span key='1'>
                                <b>Start triggers</b> will begin sending your drip sequence when a
                                certain thing happens
                            </span>,
                            <span key='2'>
                                <b>Goals</b> give you the option to stop sending your sequence when
                                a goal is met
                            </span>,
                            <span key='3'>
                                <b>Next steps</b> enable you to automate a change in Nutshell after
                                a goal is met
                            </span>,
                        ]}
                    />
                </div>
            }
            learnEvenMoreHref='https://support.nutshell.com/en/articles/8428869-campaigns-how-to-create-drip-sequences'
        />
    );
}
